import { useState } from "react";

interface IsOpenI<T> {
  show: boolean;
  row: T;
}

const useModal = <T>() => {
  const [isOpen, setIsOpen] = useState<IsOpenI<T>>({ show: false, row: {} as T });

  const onClose = () => {
    setIsOpen({ show: false, row: {} as T });
  };

  const onOpen = (row: T) => {
    setIsOpen({ show: true, row });
  };

  return {
    isOpen: isOpen.show,
    row: isOpen.row,
    close: onClose,
    open: onOpen,
  };
};

export default useModal;
